// PartnerGrid.jsx
import React from "react";

const partners = [
    {
        id: 1,
        name: "LLDIKTI 3",
        logo: "/assets/partner/logo-lldikti-3.png",
        website: "https://lldikti3.kemdikbud.go.id/",
    },
    {
        id: 2,
        name: "DAPODIK",
        logo: "/assets/partner/logo-dapodik.png",
        website: "https://dapo.kemendikdasmen.go.id/",
    },
    {
        id: 3,
        name: "EMIS",
        logo: "/assets/partner/logo-emis.png",
        website: "https://emis.kemenag.go.id/",
    },
    {
        id: 4,
        name: "Simpatika",
        logo: "/assets/partner/logo-simpatika.png",
        website: "https://simpatika.kemenag.go.id/",
    },
    {
        id: 5,
        name: "Bank BNI",
        logo: "/assets/partner/logo-bni.png",
        website: "https://www.bni.co.id/id-id/",
    },
    {
        id: 6,
        name: "Bank BRI",
        logo: "/assets/partner/logo-bri.png",
        website: "https://bri.co.id/",
    },
    {
        id: 7,
        name: "Bank BTN",
        logo: "/assets/partner/logo-btn.png",
        website: "https://www.btn.co.id/id",
    },
    {
        id: 8,
        name: "CRING",
        logo: "/assets/partner/logo-cring.png",
        website: "https://www.cring.id/",
    },
    {
        id: 9,
        name: "SPE",
        logo: "/assets/partner/logo-spe.png",
        website: "https://www.spesolution.com/",
    },
    {
        id: 10,
        name: "Indomaret",
        logo: "/assets/partner/logo-indomaret.png",
        website: "https://www.indomaret.co.id/",
    },
    {
        id: 11,
        name: "VIA",
        logo: "/assets/partner/logo-via.png",
        website: "https://www.via.id/",
    },
    {
        id: 12,
        name: "JNE",
        logo: "/assets/partner/logo-jne.png",
        website: "https://www.jne.co.id/",
    },    
];

export default function PartnerGrid() {
    return (
        <section className="py-20 bg-white">
            <div className="max-w-6xl mx-auto px-4">
                <h2 className="text-2xl font-bold mb-6 text-gray-800 text-center">
                    Our Partners
                </h2>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 items-center justify-center">
                    {partners.map((partner) => (
                        <a
                            key={partner.id}
                            href={partner.website}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex flex-col items-center justify-center p-4 border rounded-xl hover:shadow-md transition"
                        >
                            <img
                                src={partner.logo}
                                alt={partner.name}
                                className="h-32 object-contain mb-3"
                            />
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}
